<template>
  <div class="login-bg">
    <div class="login-page hold-transition">
      <div class="login-box">
        <div class="login-logo">
          <a href="#">
            <b>Dinsafer</b>Admin
          </a>
        </div>

        <!-- login form -->
        <div class="login-box-body">
          <p class="login-box-msg">Login to start your session</p>

          <form @submit.prevent="togetOnlyId">
            <div class="form-group has-feedback">
              <input
                class="form-control"
                name="username"
                placeholder="Username"
                type="text"
                v-model="username"
              >
              <span class="fa fa-user form-control-feedback"></span>
            </div>
            <div class="form-group has-feedback">
              <input
                class="form-control"
                name="password"
                placeholder="Password"
                type="password"
                v-model="password"
              >
              <span class="fa fa-lock form-control-feedback"></span>
            </div>

            <!--Verification code-->
            <div class="form-group has-feedback" v-show="isShowVerCode">
              <p class="verification-code-tips">
                The verification code has been sent to
                <strong>{{email}}</strong>
              </p>
              <input
                class="form-control"
                v-model="emailcode"
                name="emailcode"
                placeholder="Verification Code"
              >
            </div>
            <!--Verification code-->
            <div class="row">
              <!-- <div class="col-xs-8">
                <div class="checkbox icheck" id="remember-me-checkbox" v-show="false">
                  <label>
                    <input type="checkbox"> Remember Me
                  </label>
                </div>
              </div>-->
              <!-- /.col -->
              <div class="col-xs-4 pull-right">
                <button
                  type="submit"
                  class="btn btn-primary btn-block btn-flat btn-login-purple"
                >Login</button>
              </div>
              <!-- /.col -->
            </div>
          </form>
          <!-- /.col -->
        </div>

        <!-- errors -->
        <div v-if="response" class="text-purple login-response-word">
          <p>{{response}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import '../../static/js/plugins/iCheck/icheck.min.js'
import '../../static/js/plugins/iCheck/icheck.js'
import '../../static/css/icheck-purple.css'
import CryptoJS from 'crypto-js'
import global from './Global.vue'
import utils from '../utils'
import Fingerprint2 from 'fingerprintjs2'

export default {
  name: 'Login',
  data (router) {
    return {
      section: 'Login',
      loading: '',
      username: '',
      password: '',
      response: '',
      isShowVerCode: false,
      email: '',
      emailcode: ''
    }
  },
  mounted () {
    window.jQuery('#remember-me-checkbox').iCheck({
      checkboxClass: 'icheckbox_square-purple',
      radioClass: 'iradio_square-purple',
      increaseArea: '20%' // optional
    })
  },
  methods: {
    login (onlyid) {
      const { username, password, emailcode } = this

      var params = new URLSearchParams()
      var jsons = {
        uid: username,
        password: password,
        oid: onlyid,
        ecode: emailcode
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')
      /* Making API call to authenticate a user */
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      api.request('post', '/login?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          this.toggleLoading()

          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            if (data.Status === -17) {
              this.isShowVerCode = true
              this.email = data.Result
            }
            var errorName = data.ErrorMessage
            if (errorName) {
              this.response = errorName === 'InvalidCredentialsError'
                ? 'Username/Password incorrect. Please try again.'
                : errorName
            } else {
              this.response = data.error
            }
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.Result) {
            var decodeResult = this.getDecodeRC4Hex(data.Result, global.APP_SECRET)
            //              返回的数据有双引号，需要转两次json，才可以
            var myJson = JSON.parse(decodeResult)
            myJson.pw = utils.getRC4Hex(myJson.pw, global.APP_SECRET)
            this.$store.commit('SET_USER', myJson)
            this.$store.commit('SET_TOKEN', myJson.token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(myJson))
              window.localStorage.setItem('token', myJson.token)
            }

            //              this.$router.push('/')

            window.setTimeout(
              function () {
                window.location.href = '/'
              }, 200)
          }
        })
    },
    togetOnlyId () {
      var that = this
      new Fingerprint2().get(function (result, components) {
        that.login(result)
      })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    resetResponse () {
      this.response = ''
    },
    getRC4Hex (message, key) {
      var keys = CryptoJS.enc.Utf8.parse(key)
      //        加密
      var encode = CryptoJS.RC4.encrypt(message, keys)
      //        默认tostring就是to hex
      var base64code = CryptoJS.enc.Base64.parse(encode.toString())

      var encryptedHexStr = CryptoJS.enc.Hex.stringify(base64code)

      var hexsStr = encryptedHexStr.toString(CryptoJS.enc.Utf8)

      return hexsStr
    },
    getDecodeRC4Hex (encrypted, key) {
      //        解密
      //        这个必须要有
      var keys = CryptoJS.enc.Utf8.parse(key)
      //        hex解密
      var encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted)
      //        转成base64字符串
      var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      //        rc4解密
      var decrypteds = CryptoJS.RC4.decrypt(srcs, keys)

      return decrypteds.toString(CryptoJS.enc.Utf8)
    }
  }
}
</script>


<style>
html,
body,
.container-table {
  background-color: #ecf0f5;
}
.login-bg {
  background-color: #d2d6de;
  position: fixed;
  width: 100%;
  height: 100%;
}
.container-table {
  display: table;
  color: white;
}

.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.vertical-20p {
  padding-top: 20%;
}

.vertical-10p {
  padding-top: 5%;
}

.logo {
  width: 10em;
  padding: 3em;
}

.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
</style>



// WEBPACK FOOTER //
// Login.vue?7d9d3e04